// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import styled, { css } from 'styled-components';

interface ButtonProps {
  border?: boolean;
  color?: string;
}

export const Container = styled.div`
  position: relative;
  color: #fff;
  margin-top: 100px;
  z-index: 2;

  > svg {
    width: 1409px;
    height: 640px;
    position: absolute;
    top: 139px;
    left: -43px;
    bottom: 0;
    right: 0;
    z-index: 0;
    margin: auto;
  }

  @media (max-width: 1300px) {
    > svg {
      left: calc(100% - 1200px);
      width: 90%;
      height: auto;
    }
  }

  @media (max-width: 992px) {
    margin-top: 24px;

    > img {
      position: absolute;
      margin-left: -20px;
    }
  }
`;

export const StyledButton = styled.button<ButtonProps>`
  /* color: ${(props) => props.color}; */
  color: #000;
  font-size: 16px;
  border-radius: 10px;
  font-weight: 600;
  /* border: 2px solid ${(props) => props.color}; */
  border: none;
  background-color: ${(props) => props.color};
  padding: 8px 18px;
  transition: 0.3s ease-in-out;

  ${(props) =>
    props.border &&
    css`
      border: 2px solid ${(props: any) => props.color};
      color: ${(props: any) => props.color};
      background-color: transparent;
    `}

  &:hover {
    filter: brightness(0.75);

    ${(props) =>
      props.border &&
      css`
        background-color: ${(props: any) => props.color};
        color: #000;
      `}
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 3px 11px;
    border-radius: 8px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1210px;
  margin-left: auto;
  margin-right: auto;

  .card-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    transition: all 0.3s;

    &:nth-child(1) {
      margin-top: -200px;
    }
    &:nth-child(3) {
      margin-top: 200px;
    }

    .button-wrapper {
      display: flex;
      justify-content: center;
      margin-bottom: 24px;
      pointer-events: none;
      user-select: none;
      transition: all 0.3s;
    }

    .card-inside {
      padding: 32px 24px;
    }

    &:hover {
      transform: translateY(-5px);
      cursor: pointer;

      .button-wrapper {
        transform: translateY(-5px);
      }
    }
  }

  @media (max-width: 992px) {
    flex-direction: column;
    gap: 24px;

    .card-wrapper {
      &:nth-child(1) {
        margin-top: unset;
      }
      &:nth-child(3) {
        margin-top: unset;
      }

      .card-inside {
        padding: 20px;

        img {
          width: 100%;
        }
      }

      &:hover {
        transform: unset;

        .button-wrapper {
          transform: unset;
        }
      }
    }
  }
`;
